import * as S from "./styled";
import { useForm, SubmitHandler } from "react-hook-form";
import axiosInstance from "services/axiosInstance";
//Components
import LayoutWithList from "../../../LayoutModal/WithList";
import ActionButton from "../../../Button/ActionButton";
import Loading from "../../../Loading";
//hooks
import apiRequest from "../../../../hooks/apiRequest";
import { useEffect } from "react";
import useLoading from "../../../../hooks/useLoading";
//Interfaces
import { Inputs } from "Interfaces/IHeight";
import { IUpdate } from "Interfaces/IModalUpdate";

export default function Update({
  isOpenModalUpdate,
  setModalClose,
  updateList,
  selectedUrlId,
}: IUpdate) {
  const {
    register,
    handleSubmit: handleFormSubmit,
    setValue,
    formState: { errors },
  } = useForm<Inputs>();

  const { isLoading, startLoading, stopLoading } = useLoading();

  const fetchData = async () => {
    startLoading();
    try {
      const response = await axiosInstance.get(
        `height/${selectedUrlId}`
      );

      const addressData = response.data;
      for (const key in addressData) {
        setValue(key as keyof Inputs, addressData[key]);
      }

    } catch (error) {
      console.log("Error: ", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    if (selectedUrlId !== null) {
      fetchData();
    }
  }, [selectedUrlId]);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoading();
    try {
      const response = await apiRequest(
        `height/${selectedUrlId}`,
        "PUT",
        data
      );
      if (response.status === 200) {
        alert("Atualizado com sucesso!");
        updateList();
        setModalClose();
      }
    } catch (error: any) {
      alert(error.message || "Ocorreu um erro ao atualizar.");
    } finally {
      stopLoading();
    }
  };

  if (isOpenModalUpdate) {
    return (
      <LayoutWithList
        title="Atualizar Altura"
        subTitle="Atualize as informações da altura em sua base de dados."
        setModalClose={setModalClose}
      >
        {isLoading ? (
          <Loading />
        ) : (
          <S.Container>
            <S.SeparateDiv>
              <S.FormInput>
                <S.Label>
                  Altura
                  <span>*</span>
                </S.Label>
                <S.Input
                  placeholder="Informe a altura"
                  type="text"
                  {...register("height", { required: true })}
                />
                {errors.height && (
                  <S.InforErro>Campo Obrigatório</S.InforErro>
                )}
              </S.FormInput>

              <S.ContentButton>
                <ActionButton
                  name="Atualizar"
                  onClick={handleFormSubmit(onSubmit)}
                />
              </S.ContentButton>
            </S.SeparateDiv>
          </S.Container>
        )}
      </LayoutWithList>
    );
  }
  return null;
}
